export var PROCESSING_CONFIRM_WITHDRAW = 'PROCESSING_CONFIRM_WITHDRAW';
export var FINISHED_CONFIRM_WITHDRAW = 'FINISHED_CONFIRM_WITHDRAW';
export var PROCESSING_VERIFY_ADDRESS = 'PROCESSING_VERIFY_ADDRESS';
export var FINISHED_VERIFY_ADDRESS = 'FINISHED_VERIFY_ADDRESS';
export var PROCESSING_VERIFY_DEVICE = 'PROCESSING_VERIFY_DEVICE';
export var FINISHED_VERIFY_DEVICE = 'FINISHED_VERIFY_DEVICE';
export var verifyDevice = function verifyDevice(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      UserId = payload.UserId,
      d1 = payload.d1,
      hashCode = payload.hashCode;
    dispatch({
      type: PROCESSING_VERIFY_DEVICE
    });
    var fetchUrl = atob(d1);
    var fetchPayload = {
      OMSId: 1,
      PendingEmailCode: verifycode,
      UserId: Number(UserId),
      HashCode: hashCode
    };
    fetch(fetchUrl + 'RegisterNewDevice', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.result) {
        return dispatch(finishedVerifyDevice({
          error: false,
          message:
          // context.t('Your device has been successfully registered.')
          'Your device has been successfully registered.'
        }));
      }
      dispatch(finishedVerifyDevice({
        error: true,
        message:
        // context.t('Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    }).catch(function () {
      return dispatch(finishedVerifyDevice({
        error: true,
        message:
        // context.t('Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your device registration failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};
export var verifyAddress = function verifyAddress(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      AccountId = payload.AccountId,
      d1 = payload.d1;
    dispatch({
      type: PROCESSING_VERIFY_ADDRESS
    });
    var fetchUrl = atob(d1);
    var fetchPayload = {
      OMSId: 1,
      VerifyEmailCode: verifycode,
      AccountId: Number(AccountId)
    };
    fetch(fetchUrl + 'ConfirmWithdrawInfo', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (res) {
      return res.json();
    }).then(function (response) {
      if (response.result) {
        return dispatch(finishedVerifyAddress({
          error: false,
          message:
          // context.t('Your address has been successfully whitelisted.')
          'Your address has been successfully whitelisted.'
        }));
      }
      dispatch(finishedVerifyAddress({
        error: true,
        message:
        // context.t('Your whitelist confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your whitelist confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};
export var finishedVerifyAddress = function finishedVerifyAddress(payload) {
  return {
    type: FINISHED_VERIFY_ADDRESS,
    payload: payload
  };
};
export var finishedVerifyDevice = function finishedVerifyDevice(payload) {
  return {
    type: FINISHED_VERIFY_DEVICE,
    payload: payload
  };
};
export var processingConfirmWithdraw = {
  type: PROCESSING_CONFIRM_WITHDRAW
};
export var finishedConfirmWithdraw = function finishedConfirmWithdraw(payload) {
  return {
    type: FINISHED_CONFIRM_WITHDRAW,
    payload: payload
  };
};
export var fetchConfirmWithdraw = function fetchConfirmWithdraw(payload) {
  return function (dispatch) {
    var verifycode = payload.verifycode,
      userid = payload.userid,
      d1 = payload.d1;
    dispatch(processingConfirmWithdraw);
    var fetchUrl = atob(d1);
    var fetchPayload = {
      verifycode: verifycode,
      UserId: Number(userid)
    };
    fetch(fetchUrl + 'confirmwithdraw', {
      method: 'POST',
      body: JSON.stringify(fetchPayload)
    }).then(function (response) {
      if (response.ok) {
        return dispatch(finishedConfirmWithdraw({
          error: false,
          message:
          // context.t('Your withdrawal has been confirmed successfully and has started processing.')
          'Your withdrawal has been confirmed successfully and has started processing.'
        }));
      }
      dispatch(finishedConfirmWithdraw({
        error: true,
        message:
        // context.t('Your withdrawal confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.')
        'Your withdrawal confirmation failed. Try clicking the link in the email you received again. Contact the exchange admin if the problem persists.'
      }));
    });
  };
};